<template>
  <table class="mesas-table table text-nowrap">
    <thead class="thead-dark">
      <tr>
        <th scope="col">Меса</th>
        <th scope="col">Прототип</th>
        <th scope="col">Запуск<br>из инсайдера</th>
        <th scope="col">Состояние</th>
        <th scope="col">Начало</th>
        <th scope="col">Конец</th>
        <th scope="col">
          <span v-b-popover.hover.top="'Количество выполненных этапов.'">
            Прогресс
          </span>
        </th>
        <th scope="col" v-if="isActionsColumnVisible">Действия</th>
      </tr>
    </thead>
    <tr
      v-for="mesa in mesas"
      :key="mesa.protoId"
    >
      <td>
        <mesa-link v-if="isMesaLinkVisible(mesa.scheduleEntryId)" :mesaId="mesa.scheduleEntryId" label="меса" />
        <template v-if="mesa.scheduleEntryId === 0">---</template>
      </td>
      <td>{{mesa.protoId | getProtoAlias}}</td>
      <td>{{mesa.scheduleEntryId | getFromInsiderStr}}</td>
      <td :class="getPlayerMesaStatusClass(mesa.state)">
        {{mesa.state | getMesaStateName}}
      </td>
      <td>{{mesa.startStamp | getMomentStr}}</td>
      <td>{{mesa.finishStamp | getOptionalTextMomentStr('not finished')}}</td>
      <td class="text-right">
        {{mesa.progress | getFormattedNumber}}
      </td>
      <td v-if="isActionsColumnVisible" class="action-box">
        <b-button
          v-if="isFinishButtonVisible(mesa)"
          @click="finishMesa(mesa)"
          variant="warning"
          size="sm"
        >
          Завершить
        </b-button>
      </td>
    </tr>
  </table>
</template>

<script>
import auth from '../auth.js';

import { getMesaStateName         } from '../model/mesa.js';
import { getFromInsiderStr        } from '../model/mesa.js';
import { isPlayerMesaActive       } from '../model/mesa.js';
import { hasActivePlayerMesas     } from '../model/mesa.js';
import { getPlayerMesaStatusClass } from '../model/mesa.js';

import { mayEditPlayerData } from '../model/player.js';

import MesaLink from './MesaLink.vue';

export default {
  name: 'PlayerMesasTable',

  components: {
    MesaLink,
  },

  props: {
    mesas: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      actor: auth.getViewer(),
    };
  },

  computed: {
    /** @returns {boolean} */
    isActionsColumnVisible() {
      if(!this.mayEditPlayerData) {
        return false;
      }

      return this.hasMesaToFinish;
    },

    /** @returns {boolean} */
    mayEditPlayerData() {
      return mayEditPlayerData(this.actor.role);
    },

    /** @returns {boolean} */
    hasMesaToFinish() {
      return hasActivePlayerMesas(this.mesas);
    },
  },

  methods: {
    isMesaLinkVisible(mesaId) {
      return mesaId > 0;
    },

    getPlayerMesaStatusClass,

    isFinishButtonVisible(mesa) {
      if(!this.mayEditPlayerData) {
        return false;
      }

      return isPlayerMesaActive(mesa.state);
    },

    finishMesa(mesa) {
      this.$emit('mesa-finish-requested', mesa);
    },
  },

  filters: {
    getMesaStateName,
    getFromInsiderStr,
  },
}
</script>

<style scoped>
.mesas-table {
  width: 1px;
}

.action-box {
  padding: 7px;
  vertical-align: middle;
}

.action-box > .btn:last-child {
  margin-right: 0 !important;
}
</style>
